export const SECTION_COLORS = {
  patients: '#A336C9',
  schedules: '#0891B2',
  worklists: '#DC2626',
  therapyOrders: '#2563EB',
  financialHub: '#16A34A',
  orders: '#EA580C',
  inventory: '#7C3AED',
  purchasing: '#D97706',
  settings: '#6366F1',
  reports: '#0E7490',
  encounters: '#0D9488',
  management: '#B45309',
  connect: '#0284C7',
};

export const SECTION_COLOR_RGB = {
  patients: '163, 54, 201',
  schedules: '8, 145, 178',
  worklists: '220, 38, 38',
  therapyOrders: '37, 99, 235',
  financialHub: '22, 163, 74',
  orders: '234, 88, 12',
  inventory: '124, 58, 237',
  purchasing: '217, 119, 6',
  settings: '99, 102, 241',
  reports: '14, 116, 144',
  encounters: '13, 148, 136',
  management: '180, 83, 9',
  connect: '2, 132, 199',
};

export const WIDGET_THEME = {
  totalPatients: {
    header: SECTION_COLORS.patients,
    value: SECTION_COLORS.patients,
  },
  newPatients: {
    header: SECTION_COLORS.patients,
    value: SECTION_COLORS.patients,
  },
  appointmentsToday: {
    header: SECTION_COLORS.schedules,
    value: SECTION_COLORS.schedules,
  },
  activeTasks: {
    header: SECTION_COLORS.worklists,
    value: SECTION_COLORS.worklists,
  },
  pastDueTasks: {
    header: SECTION_COLORS.worklists,
    value: SECTION_COLORS.worklists,
  },
  staffingAlerts: {
    header: '#E65100',   // deep orange — signals urgency
    value:  '#F57C00',
  },
  ordersStatus: {
    header: SECTION_COLORS.therapyOrders,
    value:  SECTION_COLORS.therapyOrders,
  },
  ordersMedications: {
    header: '#0891B2',
    value:  '#0891B2',
  },
  ordersExpirations: {
    header: '#b45309',
    value:  '#b45309',
  },
  ordersProvider: {
    header: '#4472C4',
    value:  '#4472C4',
  },
};
